const UpcomingPlaceholder = () => {
  return (
    <div className="bg-gray-50 rounded px-8 py-16 text-center">
      <p className="text-2xl pb-4">There are no upcoming events at this time.</p>
    </div>
  )
}

export default UpcomingPlaceholder;